import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import type { ClockState } from '@zag/timetracking/common';

/**
 * Client of the web quick-stamp endpoints (F12, story 31-1). The backend
 * resolves the caller's own person and uses server timestamps only — the
 * requests carry no body.
 */
@Injectable({ providedIn: 'root' })
export class ClockStampService {
  private readonly http = inject(HttpClient);
  private readonly basePath = '/api/v1/time-tracking';

  getState(): Observable<ClockState> {
    return this.http.get<ClockState>(`${this.basePath}/clock-state`);
  }

  clockIn(body: { startTime?: string; homeOffice?: boolean; note?: string | null } = {}): Observable<ClockState> {
    return this.http.post<ClockState>(`${this.basePath}/clock-in`, body);
  }

  clockOut(): Observable<ClockState> {
    return this.http.post<ClockState>(`${this.basePath}/clock-out`, {});
  }
}
